const DashboardHomePage = () => {
  return (
    <div className="container h-screen">
      <div className="mt-4 text-4xl">Hi 👋, Welcome to Admin Panel</div>
      <div className="mt-4 text-4xl"><b>This is a Demo.</b></div>
    </div>
  );
};

export default DashboardHomePage;
